<div class="show-hide-container">

  <div>
    <h3 class="text-accent dialog-title">Show/Hide Columns</h3>
    <div class="divider bg-accent chamfer"></div>
  </div>

</div>

<div class="show-hide-columns-container">
  <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
    [indeterminate]="selection.hasValue() && !isAllSelected()"> Select All
  </mat-checkbox>


  <div class="list-container margin-8-top">
    <div class="columns-list">
      <mat-checkbox *ngFor="let column of totalColumns"
        (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(column) : null"
        [checked]="selection.isSelected(column)" [value]="column" [disabled]="isFrozen(column)">
        {{ mapping[column] }}
      </mat-checkbox>
    </div>
  </div>
  <div class="text-center save-button-container">
    <button color="warn" type="submit" mat-stroked-button (click)="closeDialog()">Cancel</button>

    <button color="accent" (click)="addColumns()" mat-flat-button> Save </button>
  </div>

</div>
